var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.943,
    height: 23.207,
    viewBox: "0 0 30.943 23.207",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-envelope",
    "data-name": "Icon awesome-envelope",
    d: "M30.356,12.163a.364.364,0,0,1,.586.284V24.806a2.9,2.9,0,0,1-2.9,2.9H2.9a2.9,2.9,0,0,1-2.9-2.9V12.453a.361.361,0,0,1,.586-.284C1.94,13.221,3.735,14.556,9.9,19.035c1.275.931,3.427,2.889,5.572,2.877,2.158.018,4.351-1.982,5.578-2.877C27.214,14.556,29,13.215,30.356,12.163ZM15.471,19.971c1.4.024,3.421-1.765,4.436-2.5,8.02-5.82,8.63-6.328,10.479-7.778a1.446,1.446,0,0,0,.556-1.142V7.4a2.9,2.9,0,0,0-2.9-2.9H2.9A2.9,2.9,0,0,0,0,7.4V8.549A1.455,1.455,0,0,0,.556,9.691c1.849,1.444,2.46,1.958,10.479,7.778C12.051,18.207,14.069,20,15.471,19.971Z",
    transform: "translate(0 -4.5)",
    fill: "#7a7256"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.e67bbb2f26209915f66008a06cdf735c.svg";
export { ForwardRef as ReactComponent };